import styles from "./styles/Tab.module.css";
import cn from "classnames";
import { ReactNode } from "react";
import { IconButton } from "components/Button/IconButton";
import { IconCross } from "components/Icons/IconCross";
import Link, { LinkProps } from "next/link";

interface Props {
  children: ReactNode;
  href: LinkProps["href"];
  replace?: LinkProps["replace"];
  shallow?: LinkProps["shallow"];
  active: boolean;
  onClick?: () => void;
  onDismiss?: () => void;
}

export const TabLink: React.FC<Props> = (props) => {
  const { href, replace, active, onDismiss, shallow } = props;

  return (
    <Link href={href} replace={replace} shallow={shallow}>
      <a
        className={cn(
          styles.tab,
          active && styles.active,
          onDismiss && styles.dismissible
        )}
        onClick={props.onClick}
      >
        {props.children}

        {onDismiss && (
          <IconButton
            theme="ghost"
            size="XS"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onDismiss();
            }}
            aria-label="Remove"
          >
            <IconCross />
          </IconButton>
        )}
      </a>
    </Link>
  );
};
